import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
  const [walletBalance, setWalletBalance] = useState(0);
  const [userAddress, setUserAddress] = useState("");

  useEffect(() => {
    const address = localStorage.getItem("userAddress");
    if (address) {
      setUserAddress(address);
    }
  }, []);

  const fetchWalletBalance = async () => {
    if (!userAddress) return;

    try {
      const response = await axios.get("https://backend.bait-coin.com/getTokens", {
        params: { userAddress, chain: "gold" },
      });
      if (response.data?.balance !== undefined) {
        setWalletBalance(response.data.balance);
      }
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };

  useEffect(() => {
    if (userAddress) {
      fetchWalletBalance();
    }
  }, [userAddress]);

  return (
    <WalletContext.Provider
      value={{
        walletBalance,
        userAddress,
        setWalletBalance,
        setUserAddress,
        fetchWalletBalance,
      }}
    >
      {children}
    </WalletContext.Provider>
  );
};
